import { PkCommonHelper } from "src/pkScripts/Helpers/PkCommonHelper";
import { Card, CardGetMethod, CardGetMode } from "tessa/cards";
import { CardGetFileContentRequest, CardGetRequest, CardService } from "tessa/cards/service";
import { DotNetType } from "tessa/platform";
import { showError } from "tessa/ui";
import { FileViewModel } from "tessa/ui/cards/controls";
import { CdExecutiveDocumentationClientHelper } from "../Helpers/Cards/CdExecutiveDocumentationClientHelper";
import { CdCardTypes } from "../Helpers/CdCardTypes";
import { CdFileTypes } from "../Helpers/CdFileTypes";

export class CdContextMenuFileHelper {

    public static async SaveFileForPrintVirtual(cardId: DotNetType.Guid, fileId: string) {
        const getRequest = new CardGetRequest();
        getRequest.cardId = cardId;
        getRequest.cardTypeId = CdCardTypes.PkExecutiveSchemeTypeID;
        getRequest.getMode = CardGetMode.ReadOnly;
        getRequest.method = CardGetMethod.Backup;
    
        // загружаем карточку
        const getResponse = await CardService.instance.get(getRequest);
        if (!getResponse.validationResult.isSuccessful) {
          return;
        }
    
        const card = getResponse.card;
        if (!card.files.find(x => x.rowId === fileId)) {
          return;
        }
    
        const file = card.files.find(x => x.rowId === fileId);
        if (!file || !file.lastVersion || !file.lastVersion.rowId) {
          return;
        }
    
        this.Log('Формирование запроса');
    
        const getFileContentRequest = new CardGetFileContentRequest();
        getFileContentRequest.fileTypeName = CdFileTypes.GetFileForPrintType;
        getFileContentRequest.cardId = cardId;
        getFileContentRequest.versionRowId = file.lastVersion.rowId;
        getFileContentRequest.fileId = file.rowId;
        getFileContentRequest.fileName = file.name;
    
        this.Log('Отправка запроса на сервер');
    
        const getFileContentResponse = await CardService.instance.getFileContent(getFileContentRequest);
    
        if (!getFileContentResponse.validationResult.isSuccessful) {
          await showError('Не удалось получить файл. Подробнее: F12 -> Console');
          this.Error('Ошибка на сервере: ' + getFileContentResponse.validationResult.build().toString());
          return;
        }
    
        this.Log('Получен ответ от сервера');
    
        if (getFileContentResponse.content != null &&
          getFileContentResponse.size !== 0) {
          const fileName: string = this.GetFileName(file.name, CdExecutiveDocumentationClientHelper.PdfForPrint);
          this.Info('Длина файла "' + fileName + '": ' + getFileContentResponse.size);
          PkCommonHelper.SaveFileContent(fileName, getFileContentResponse.content);
        } else {
          this.Error('Вернулся пустой файл');
        }
      }
    
  public static async SaveFileForPrint(file: FileViewModel, card: Card, fileTypeName: string, cardTypeId: string, cardTypeName: string, extension: string, info?: any) {
    this.Log('Формирование запроса');

    // CardTypeID обязательно, используется в расширении
    const getFileContentRequest = new CardGetFileContentRequest();
    getFileContentRequest.fileTypeName = fileTypeName;
    getFileContentRequest.cardId = card.id;
    getFileContentRequest.versionRowId = file.model.lastVersion.id;
    getFileContentRequest.fileId = file.model.id;
    getFileContentRequest.fileName = file.model.name;
    getFileContentRequest.cardTypeId = cardTypeId;
    getFileContentRequest.cardTypeName = cardTypeName;
    getFileContentRequest.info = info;

    this.Log('Отправка запроса на сервер');

    const getFileContentResponse = await CardService.instance.getFileContent(getFileContentRequest);

    if (!getFileContentResponse.validationResult.isSuccessful) {
      await showError('Не удалось получить файл. Подробнее: F12 -> Console');
      this.Error('Ошибка на сервере: ' + getFileContentResponse.validationResult.build().toString());
      return;
    }

    this.Log('Получен ответ от сервера');

    if (getFileContentResponse.content != null &&
      getFileContentResponse.size !== 0) {
      const fileName: string = this.GetFileName(file.model.name, extension);
      this.Info('Длина файла "' + fileName + '": ' + getFileContentResponse.size);
      PkCommonHelper.SaveFileContent(fileName, getFileContentResponse.content);
    } else {
      this.Error('Вернулся пустой файл');
    }
  }

  // ПОлучить имя файла для печати
  private static GetFileName(currentName: string, extension: string) {
    let pointIndex: number = currentName.lastIndexOf('.');
    if (pointIndex > 0) {
      currentName = currentName.substring(0, pointIndex) + extension;
    }
    return currentName;
  }

  private static Error(message: string) {
    console.error('[Печатная форма|Ошибка] ' + message);
    return message;
  }

  private static Log(message: string) {
    console.log('[Печатная форма|Сообщение] ' + message);
  }

  private static Info(message: string) {
    console.info('[Печатная форма|Информация] ' + message);
  }
}